import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Drop-in replacement for <input type="password"> that reveals characters
// while the user holds/toggles an eye button on the right. Passes through
// className/data-testid/etc so styling stays visually identical to the rest
// of the form.
export default function PasswordInput({ className = "", "data-testid": dataTestId, ...rest }) {
  const [show, setShow] = useState(false);
  const testid = dataTestId || "password-input";
  return (
    <div className="relative">
      <input
        {...rest}
        type={show ? "text" : "password"}
        className={`${className} pr-10`}
        data-testid={testid}
        autoComplete={rest.autoComplete ?? (show ? "off" : "current-password")}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-2 my-auto h-6 w-6 grid place-items-center text-[#A3A3A3] hover:text-[#CCFF00] transition-colors"
        data-testid={`${testid}-toggle`}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
